// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)

// ** Axios Imports
import axios from 'axios'
import { formatTimestamp } from '@utils'

export const getAll = createAsyncThunk('productivity/getAll', async (date) => {
  const response = await axios.get(`/productivity?date=${formatTimestamp(date)}`)
  return response.data
})
  export const updateStatus = createAsyncThunk(
    'productivity/updateStatus',
    async (data, { dispatch, rejectWithValue }) => {
      try {
        const response = await axios.patch(`/productivity/${data.id}`, data)
        await dispatch(getAll(data.date))
        return response.data
      } catch (error) {
        if (error.response && error.response.status === 400) {
          // Mengambil pesan kesalahan dari respons JSON jika status kode 409
          const errorMessage = error.response.data
          return rejectWithValue(errorMessage)
        } else {
          throw error // Melanjutkan melempar kesalahan untuk penanganan umum
        }
      }
    }
  )
  

export const dataSlice = createSlice({
  name: 'productivity',
  initialState: {
    results: [],
    isLoading: false
  },
  reducers: {
    selectData: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAll.pending, (state) => {
        state.isLoading = true
        state.results = []
      })
      .addCase(getAll.fulfilled, (state, action) => {
        state.isLoading = false
        state.results = action.payload
      })
      
      .addCase(updateStatus.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateStatus.rejected, (state) => {
        state.isLoading = false
        MySwal.fire({
          title: 'Failed!',
          text: 'Update failed',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
        
      })
      .addCase(updateStatus.fulfilled, (state) => {
        state.isLoading = false
      })
  }
})
export default dataSlice.reducer
